
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    button: {
      type: String,
      default: "primary",
    },
    link: {
      type: [String, Object],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    buttonStyle() {
      let classes;

      if (this.button === "primary") {
        classes =
          "text-white bg-primary-red-100 md:hover:bg-primary-red-200 border-transparent";
      } else if (this.button === "secondary") {
        classes =
          "md:hover:text-white md:hover:bg-tertiary-gray-500 border-tertiary-gray-500";
      } else {
        classes =
          "border-transparent bg-white md:hover:bg-tertiary-gray-500 text-tertiary-gray-500 md:hover:text-white";
      }

      return classes;
    },
  },
};
